import * as angular from "angular";
import * as _ from "lodash";
import {Endpoints} from "../../shared/config/constant.module";
import SignalRHubName, {SignalRHub, SignalRHubCtor, SignalRHubOptions, SignalRHubOptionsBase} from "./signalr-hub";
import EnvironmentName, {Environment} from "../../shared/config/environment";
let requires = [SignalRHubName, EnvironmentName];

export interface HubService {
  createHub<T extends SignalRHub>(name: string, options: SignalRHubOptionsBase): T;
}

export default angular.module('aps.services.hubs', requires)
  .service('hubService', function(/* tslint:disable:variable-name */
                                  Hub: SignalRHubCtor,
                                  /* tslint:enable:variable-name */
                                  environment: Environment): HubService {
    let defaultOptions = {
      rootPath: environment.API_PATH + Endpoints.SIGNALR,
      logging: true
    };

    function createHub<T extends SignalRHub>(name: string, options: SignalRHubOptionsBase): T {
      return <T>(new Hub(_.defaults<SignalRHubOptions>(options || {}, {
        name: name
      }, defaultOptions)));
    }

    return {
      createHub: createHub
    };
  }).name;


// WEBPACK FOOTER //
// ./src/app/services/hubs/hub.service.ts